import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LanguageService } from '@trading-fe/services';

export const serviceUnavailableGuard: CanActivateFn = () => {
  const router = inject(Router);
  const langService = inject(LanguageService);

  if (sessionStorage.getItem('serviceUnavailable') === 'true') {
    return true;
  }

  return router.parseUrl(langService.langUrl('/'));
};
